// src/pages/TermsOfServicePage.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import LandingHeader from '../components/LandingHeader';
import LandingFooter from '../components/LandingFooter';
import '../styles/pages/TermsOfServicePage.scss';

const TermsOfServicePage = () => {
    return (
        <>
            <Helmet>
                <title>利用規約 - Suisui</title>
                <meta name="description" content="Suisuiの利用規約をご確認ください。現在開発中のサービスです。" />
            </Helmet>

            <div className="terms-page">
                {/* ヘッダー */}
                <LandingHeader showNavButton={true} />

                {/* メインコンテンツ */}
                <div className="terms-main">
                    <div className="container">
                        <div className="terms-content">
                            <h1 className="terms-title">利用規約</h1>
                            <p className="terms-updated">最終更新日: 2025年1月22日</p>

                            {/* 重要な注意事項 */}
                            <div className="terms-notice">
                                <h2>⚠️ 重要な注意事項</h2>
                                <div className="notice-content">
                                    <p><strong>本サービスは現在開発中です。実際の業務や重要な用途での利用はお控えください。</strong></p>
                                    <p>開発段階のため、予告なくサービスの停止、データの消失、機能の変更が発生する可能性があります。</p>
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>第1条（適用）</h2>
                                <p>
                                    本規約は、Suisui（以下「当サービス」）の利用に関して、当サービスの提供者（以下「当社」）と利用者との間の権利義務関係を定めるものです。
                                </p>
                            </div>

                            <div className="terms-section">
                                <h2>第2条（サービスの性質）</h2>
                                <p>当サービスは開発段階にあり、以下の特性があります：</p>
                                <ul>
                                    <li>機能やデザインが予告なく変更される場合があります</li>
                                    <li>データの保証や永続性は提供されません</li>
                                    <li>サービスの安定性や可用性は保証されません</li>
                                    <li>実際の業務での利用は推奨されません</li>
                                </ul>
                            </div>

                            <div className="terms-section">
                                <h2>第3条（利用条件）</h2>
                                <p>利用者は以下の条件に同意したうえで、当サービスを利用するものとします：</p>
                                <ul>
                                    <li>本サービスがテスト・開発目的であることを理解している</li>
                                    <li>重要なデータやコンテンツの保存場所として利用しない</li>
                                    <li>商用利用や業務利用を行わない</li>
                                    <li>サービスの不具合やデータ損失があっても異議を申し立てない</li>
                                </ul>
                            </div>

                            <div className="terms-section">
                                <h2>第4条（禁止事項）</h2>
                                <p>利用者は以下の行為を行ってはなりません：</p>
                                <ul>
                                    <li>法令に違反する行為</li>
                                    <li>他の利用者や第三者の権利を侵害する行為</li>
                                    <li>当サービスの運営を妨害する行為</li>
                                    <li>不正アクセスやシステムへの攻撃</li>
                                    <li>虚偽の情報を登録・投稿する行為</li>
                                    <li>商用目的での利用</li>
                                </ul>
                            </div>

                            <div className="terms-section">
                                <h2>第5条（免責事項）</h2>
                                <p><strong>当社は、当サービスの利用に関して一切の責任を負いません。</strong></p>
                                <p>具体的には以下を含みますが、これらに限定されません：</p>
                                <ul>
                                    <li>サービスの中断、停止、終了によって生じた損害</li>
                                    <li>データの消失、破損によって生じた損害</li>
                                    <li>セキュリティ上の問題によって生じた損害</li>
                                    <li>サービスの不具合や障害によって生じた損害</li>
                                    <li>利用者間のトラブルによって生じた損害</li>
                                    <li>その他当サービスの利用に関連して生じた一切の損害</li>
                                </ul>
                            </div>

                            <div className="terms-section">
                                <h2>第6条（サービスの変更・終了）</h2>
                                <p>
                                    当社は、利用者への事前通知なく、当サービスの内容の変更や提供の停止・終了を行うことができます。
                                    これにより利用者に損害が生じた場合も、当社は一切責任を負いません。
                                </p>
                            </div>

                            <div className="terms-section">
                                <h2>第7条（データの取り扱い）</h2>
                                <p>
                                    利用者が当サービスに投稿・保存したデータについて、当社は保存や復旧の義務を負いません。
                                    重要なデータは必ず利用者自身でバックアップを取ってください。
                                </p>
                            </div>

                            <div className="terms-section">
                                <h2>第8条（規約の変更）</h2>
                                <p>
                                    当社は、利用者への個別の通知なく、本規約を変更することができます。
                                    変更後の規約は、当サイトに掲載された時点で効力を生じます。
                                </p>
                            </div>

                            <div className="terms-section">
                                <h2>第9条（準拠法・管轄）</h2>
                                <p>
                                    本規約は日本法に準拠し、当サービスに関する一切の紛争については、
                                    当社の所在地を管轄する裁判所を専属的合意管轄裁判所とします。
                                </p>
                            </div>

                            <div className="terms-notice terms-bottom-notice">
                                <p><strong>本サービスを利用することで、上記の利用規約に同意したものとみなされます。</strong></p>
                                <p>開発中のサービスであることを十分ご理解の上、ご利用ください。</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* フッター */}
                <LandingFooter />
            </div>
        </>
    );
};

export default TermsOfServicePage;
